import * as React from "react";
import {
  Button,
  Checkbox,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Switch,
  TextField,
  Theme,
  withStyles,
  Zoom,
} from "@material-ui/core";

import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import InsurancePlanResult from "./InsurancePlanResult";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IInsurancePlanState {
  binNumber: string;
  binNumber2: string;
  binNumber3: string;
  cardHolderId: string;
  cardHolderId2: string;
  cardHolderId3: string;
  formSubmitted: boolean;
  groupNumber: string;
  groupNumber2: string;
  groupNumber3: string;
  message: string;
  open: boolean;
  pcn: string;
  pcn2: string;
  pcn3: string;
  personId: string;
  resultSuccessful: boolean;
  setInsuranceAsPrimary: boolean;
  setInsuranceAsPrimary2: boolean;
  setInsuranceAsPrimary3: boolean;
  showAdditionalInsurancesFields: boolean;
  showAdditionalInsurancesFields2: boolean;
  spi: string;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class InsurancePlanSection extends React.Component<any, IInsurancePlanState> {
  constructor(props: any) {
    super(props);
    this.state = {
      binNumber: "456789",
      binNumber2: "",
      binNumber3: "",
      cardHolderId: "123456789",
      cardHolderId2: "",
      cardHolderId3: "",
      formSubmitted: false,
      groupNumber: "",
      groupNumber2: "",
      groupNumber3: "",
      message: "",
      open: false,
      pcn: "XPAY",
      pcn2: "",
      pcn3: "",
      personId: "",
      resultSuccessful: false,
      setInsuranceAsPrimary: true,
      setInsuranceAsPrimary2: false,
      setInsuranceAsPrimary3: false,
      showAdditionalInsurancesFields: false,
      showAdditionalInsurancesFields2: false,
      spi: "6633950178005",
    };

    this.handlePersonId = this.handlePersonId.bind(this);
    this.handleShowAdditionalInsurancesFields =
      this.handleShowAdditionalInsurancesFields.bind(this);
    this.handleShowAdditionalInsurancesFields2 =
      this.handleShowAdditionalInsurancesFields2.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePrimaryDoctor = this.handlePrimaryDoctor.bind(this);
    this.handleCardHolderId = this.handleCardHolderId.bind(this);
    this.handleCardHolderId2 = this.handleCardHolderId2.bind(this);
    this.handleCardHolderId3 = this.handleCardHolderId3.bind(this);
    this.handleBinNumber = this.handleBinNumber.bind(this);
    this.handleBinNumber2 = this.handleBinNumber2.bind(this);
    this.handleBinNumber3 = this.handleBinNumber3.bind(this);
    this.handlePcn = this.handlePcn.bind(this);
    this.handlePcn2 = this.handlePcn2.bind(this);
    this.handlePcn3 = this.handlePcn3.bind(this);
    this.handleGroupNumber = this.handleGroupNumber.bind(this);
    this.handleGroupNumber2 = this.handleGroupNumber2.bind(this);
    this.handleGroupNumber3 = this.handleGroupNumber3.bind(this);
    this.handleSetInsuranceAsPrimary =
      this.handleSetInsuranceAsPrimary.bind(this);
    this.handleSetInsuranceAsPrimary2 =
      this.handleSetInsuranceAsPrimary2.bind(this);
    this.handleSetInsuranceAsPrimary3 =
      this.handleSetInsuranceAsPrimary3.bind(this);
  }

  public render() {
    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="Person Id (Required)"
              variant="outlined"
              value={this.state.personId}
              onChange={this.handlePersonId}
            />
          </Grid>

          <Grid item xs>
            <FormControl>
              <InputLabel>Primary Doctor (Required)</InputLabel>
              <Select
                value={this.state.spi}
                style={{ width: 225 }}
                onChange={this.handlePrimaryDoctor}
              >
                <MenuItem value="1013626948011">
                  <em>
                    Kristina Bowen, KVH Orthopedics, 611 S Chestnut St, Ste D,
                    Ellensburg, WA, 98926, Phone number: (509) 933-8700
                  </em>
                </MenuItem>
                <MenuItem value="6633950178005">
                  <em>
                    JOHN KIHM, regional medical associates, p, 3811 N Roxboro
                    St, Ste B, Durham, NC, 27704, Phone number: (919) 471-3351
                  </em>
                </MenuItem>
                <MenuItem value="6299122013003">
                  <em>
                    Robert Mackinder, Spectrum Health, 7128 Fulton St E, Ada,
                    MI, 49301, Phone number: (616) 825-3530
                  </em>
                </MenuItem>
                <MenuItem value="6261285632002">
                  <em>
                    Gregory Granrud, Healtheast Heart Care Physicians, 45 10th
                    St W, Saint Paul, MN, 55102, Phone number: (651) 326-4327
                  </em>
                </MenuItem>
                <MenuItem value="5081356803001">
                  <em>
                    DANIEL BROWNFIELD, 2606 Hospital Blvd, Ste B, Corpus
                    Christi, TX, 78405, Phone number: (361) 902-4789
                  </em>
                </MenuItem>
                <MenuItem value="8208966520001">
                  <em>
                    Gary Schneider, DO, 3139 Highland Ave 2nd Floor Interna,
                    Cincinnati, OH, 45219, Phone number: (513) 584-4505
                  </em>
                </MenuItem>
                <MenuItem value="6594995717002">
                  <em>
                    Brian Loskill, LOSKILL, BRIAN, 3029 Newcastle Loop, Myrtle
                    Beach, SC, 29588, Phone number: (843) 215-8868
                  </em>
                </MenuItem>
                <MenuItem value="6809068276002">
                  <em>
                    Sarah Bragg, UABC, 1141 Payton Way, Leeds, AL, 35094, Phone
                    number: (205) 699-0729
                  </em>
                </MenuItem>
                <MenuItem value="6728920896018">
                  <em>
                    Yasmin Deliz, DO Linwood, 2106 New Rd, Ste D4, Linwood, NJ,
                    08221, Phone number: (609) 926-8899
                  </em>
                </MenuItem>
                <MenuItem value="6013294536008">
                  <em>
                    Cynthia Kang-Rotondo, Greater Knoxville Dermatology, 7730
                    Dannaher Dr, Powell, TN 37849, Phone number: (865) 524-7107
                  </em>
                </MenuItem>
                <MenuItem value="6044315631005">
                  <em>
                    James Bertel, 100 Kings Way E, Ste D2, Sewell, NJ 08080,
                    Phone number: (844) 542-2273
                  </em>
                </MenuItem>
                <MenuItem value="6145116342004">
                  <em>
                    Hugo Twaddle, 2649 Schoenersville Rd, Ste 201, Bethlehem, PA
                    18017, Phone number: (484) 884-8110
                  </em>
                </MenuItem>
                <MenuItem value="6794505076010">
                  <em>
                    Sarah Carpenter, 65-1267, Kawaihae Road, Kamuela, HI 96743,
                    Phone number: (808) 881-4745
                  </em>
                </MenuItem>
                <MenuItem value="8215456027200">
                  <em>
                    Joseph Abayev, 3750 Ralph Avenue, Apartment 417, Owensboro,
                    KY 42303, Phone number: (888) 402-6916
                  </em>
                </MenuItem>
                <MenuItem value="6582785534001">
                  <em>
                    Myna Kuo, 414 Uluniu St, Kailua, HI 96734-2556, Phone
                    number: (808)523-1600 Fax: 8085260221
                  </em>
                </MenuItem>
                <MenuItem value="6977486979012">
                  <em>
                    Aarti Kulkarni, 9725 Wilshire Boulevard, Beverly Hills, CA
                    90212, Phone number: (888) 663-6331 Fax: 4152527176
                  </em>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="MEMBER ID # (Required)"
              variant="outlined"
              value={this.state.cardHolderId}
              onChange={this.handleCardHolderId}
            />
          </Grid>

          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RXBIN # (Required)"
              variant="outlined"
              value={this.state.binNumber}
              onChange={this.handleBinNumber}
            />
          </Grid>

          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RX GROUP # (Optional)"
              variant="outlined"
              value={this.state.groupNumber}
              onChange={this.handleGroupNumber}
            />
          </Grid>

          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RXPCN # (Optional)"
              variant="outlined"
              value={this.state.pcn}
              onChange={this.handlePcn}
            />
          </Grid>

          <Grid item xs>
            <FormControl component="fieldset">
              <FormGroup style={{ width: 225 }}>
                <FormControlLabel
                  control={
                    <Checkbox checked={this.state.setInsuranceAsPrimary} />
                  }
                  label="Set Insurance As Primary"
                  onChange={this.handleSetInsuranceAsPrimary}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <FormControlLabel
            control={
              <Switch
                checked={this.state.showAdditionalInsurancesFields}
                onChange={this.handleShowAdditionalInsurancesFields}
              />
            }
            label="Add more insurance"
          />

          {this.state.showAdditionalInsurancesFields && (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              spacing={3}
            >
              <Zoom
                in={this.state.showAdditionalInsurancesFields}
                style={{
                  transitionDelay: this.state.showAdditionalInsurancesFields
                    ? "500ms"
                    : "0ms",
                }}
              >
                <Grid item xs>
                  <TextField
                    style={{ width: 225 }}
                    label="MEMBER ID # (Required)"
                    variant="outlined"
                    value={this.state.cardHolderId2}
                    onChange={this.handleCardHolderId2}
                  />
                </Grid>
              </Zoom>

              <Zoom
                in={this.state.showAdditionalInsurancesFields}
                style={{
                  transitionDelay: this.state.showAdditionalInsurancesFields
                    ? "500ms"
                    : "0ms",
                }}
              >
                <Grid item xs>
                  <TextField
                    style={{ width: 225 }}
                    label="RXBIN # (Required)"
                    variant="outlined"
                    value={this.state.binNumber2}
                    onChange={this.handleBinNumber2}
                  />
                </Grid>
              </Zoom>

              <Zoom
                in={this.state.showAdditionalInsurancesFields}
                style={{
                  transitionDelay: this.state.showAdditionalInsurancesFields
                    ? "500ms"
                    : "0ms",
                }}
              >
                <Grid item xs>
                  <TextField
                    style={{ width: 225 }}
                    label="RX GROUP # (Optional)"
                    variant="outlined"
                    value={this.state.groupNumber2}
                    onChange={this.handleGroupNumber2}
                  />
                </Grid>
              </Zoom>

              <Zoom
                in={this.state.showAdditionalInsurancesFields}
                style={{
                  transitionDelay: this.state.showAdditionalInsurancesFields
                    ? "500ms"
                    : "0ms",
                }}
              >
                <Grid item xs>
                  <TextField
                    style={{ width: 225 }}
                    label="RXPCN # (Optional)"
                    variant="outlined"
                    value={this.state.pcn2}
                    onChange={this.handlePcn2}
                  />
                </Grid>
              </Zoom>

              <Zoom
                in={this.state.showAdditionalInsurancesFields}
                style={{
                  transitionDelay: this.state.showAdditionalInsurancesFields
                    ? "500ms"
                    : "0ms",
                }}
              >
                <Grid item xs>
                  <FormControl component="fieldset">
                    <FormGroup style={{ width: 225 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.setInsuranceAsPrimary2}
                          />
                        }
                        label="Set Insurance As Primary"
                        onChange={this.handleSetInsuranceAsPrimary2}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Zoom>

              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.showAdditionalInsurancesFields2}
                    onChange={this.handleShowAdditionalInsurancesFields2}
                  />
                }
                label="Add more insurance"
              />

              {this.state.showAdditionalInsurancesFields2 && (
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  spacing={3}
                >
                  <Zoom
                    in={this.state.showAdditionalInsurancesFields2}
                    style={{
                      transitionDelay: this.state
                        .showAdditionalInsurancesFields2
                        ? "500ms"
                        : "0ms",
                    }}
                  >
                    <Grid item xs>
                      <TextField
                        style={{ width: 225 }}
                        label="MEMBER ID # (Required)"
                        variant="outlined"
                        value={this.state.cardHolderId3}
                        onChange={this.handleCardHolderId3}
                      />
                    </Grid>
                  </Zoom>

                  <Zoom
                    in={this.state.showAdditionalInsurancesFields2}
                    style={{
                      transitionDelay: this.state
                        .showAdditionalInsurancesFields2
                        ? "500ms"
                        : "0ms",
                    }}
                  >
                    <Grid item xs>
                      <TextField
                        style={{ width: 225 }}
                        label="RXBIN # (Required)"
                        variant="outlined"
                        value={this.state.binNumber3}
                        onChange={this.handleBinNumber3}
                      />
                    </Grid>
                  </Zoom>

                  <Zoom
                    in={this.state.showAdditionalInsurancesFields2}
                    style={{
                      transitionDelay: this.state
                        .showAdditionalInsurancesFields2
                        ? "500ms"
                        : "0ms",
                    }}
                  >
                    <Grid item xs>
                      <TextField
                        style={{ width: 225 }}
                        label="RX GROUP # (Optional)"
                        variant="outlined"
                        value={this.state.groupNumber3}
                        onChange={this.handleGroupNumber3}
                      />
                    </Grid>
                  </Zoom>

                  <Zoom
                    in={this.state.showAdditionalInsurancesFields2}
                    style={{
                      transitionDelay: this.state
                        .showAdditionalInsurancesFields2
                        ? "500ms"
                        : "0ms",
                    }}
                  >
                    <Grid item xs>
                      <TextField
                        style={{ width: 225 }}
                        label="RXPCN # (Optional)"
                        variant="outlined"
                        value={this.state.pcn3}
                        onChange={this.handlePcn3}
                      />
                    </Grid>
                  </Zoom>

                  <Zoom
                    in={this.state.showAdditionalInsurancesFields2}
                    style={{
                      transitionDelay: this.state
                        .showAdditionalInsurancesFields2
                        ? "500ms"
                        : "0ms",
                    }}
                  >
                    <Grid item xs>
                      <FormControl component="fieldset">
                        <FormGroup style={{ width: 225 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.setInsuranceAsPrimary3}
                              />
                            }
                            label="Set Insurance As Primary"
                            onChange={this.handleSetInsuranceAsPrimary3}
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  </Zoom>
                </Grid>
              )}
            </Grid>
          )}

          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <InsurancePlanResult
                resultSuccessful={this.state.resultSuccessful}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Script Chase Response"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </Grid>
    );
  }

  public handleShowAdditionalInsurancesFields(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    this.setState({
      showAdditionalInsurancesFields:
        !this.state.showAdditionalInsurancesFields,
    });
    if (!this.state.showAdditionalInsurancesFields) {
      this.setState({ showAdditionalInsurancesFields2: false });
    }
  }

  public handleShowAdditionalInsurancesFields2(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    this.setState({
      showAdditionalInsurancesFields2:
        !this.state.showAdditionalInsurancesFields2,
    });
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handlePersonId(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ personId: event.target.value });
  }

  public handlePrimaryDoctor(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ spi: event.target.value });
  }

  public handleCardHolderId(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ cardHolderId: event.target.value });
  }

  public handleBinNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ binNumber: event.target.value });
  }

  public handleGroupNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ groupNumber: event.target.value });
  }

  public handlePcn(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ pcn: event.target.value });
  }

  public handleSetInsuranceAsPrimary(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    if (event.target.checked) {
      this.setState({ setInsuranceAsPrimary: true });
      this.setState({ setInsuranceAsPrimary2: false });
      this.setState({ setInsuranceAsPrimary3: false });
    } else {
      this.setState({ setInsuranceAsPrimary: false });
      this.setState({ setInsuranceAsPrimary2: false });
      this.setState({ setInsuranceAsPrimary3: false });
    }
  }

  public handleCardHolderId2(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ cardHolderId2: event.target.value });
  }

  public handleBinNumber2(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ binNumber2: event.target.value });
  }

  public handleGroupNumber2(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ groupNumber2: event.target.value });
  }

  public handlePcn2(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ pcn2: event.target.value });
  }

  public handleSetInsuranceAsPrimary2(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    if (event.target.checked) {
      this.setState({ setInsuranceAsPrimary: false });
      this.setState({ setInsuranceAsPrimary2: true });
      this.setState({ setInsuranceAsPrimary3: false });
    } else {
      this.setState({ setInsuranceAsPrimary: false });
      this.setState({ setInsuranceAsPrimary2: false });
      this.setState({ setInsuranceAsPrimary3: false });
    }
  }

  public handleCardHolderId3(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ cardHolderId3: event.target.value });
  }

  public handleBinNumber3(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ binNumber3: event.target.value });
  }

  public handleGroupNumber3(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ groupNumber3: event.target.value });
  }

  public handlePcn3(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ pcn3: event.target.value });
  }

  public handleSetInsuranceAsPrimary3(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    if (event.target.checked) {
      this.setState({ setInsuranceAsPrimary: false });
      this.setState({ setInsuranceAsPrimary2: false });
      this.setState({ setInsuranceAsPrimary3: true });
    } else {
      this.setState({ setInsuranceAsPrimary: false });
      this.setState({ setInsuranceAsPrimary2: false });
      this.setState({ setInsuranceAsPrimary3: false });
    }
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.personId) {
      alert("Please enter the person id");
      formIsValid = false;
    } else if (
      !this.state.personId.match(
        "^amzn[1-9]+[0-9]*.([A-Za-z0-9]+.)+A[A-Z0-9]*$"
      )
    ) {
      alert("Please enter the valid personId.");
      formIsValid = false;
    } else if (!this.state.cardHolderId) {
      alert("Please enter the member id");
      formIsValid = false;
    } else if (!this.state.binNumber) {
      alert("Please enter the rxbin");
      formIsValid = false;
    } else if (
      this.state.showAdditionalInsurancesFields &&
      !this.state.cardHolderId2
    ) {
      alert("Please enter the member id");
      formIsValid = false;
    } else if (
      this.state.showAdditionalInsurancesFields &&
      !this.state.binNumber2
    ) {
      alert("Please enter the rxbin");
      formIsValid = false;
    } else if (
      this.state.showAdditionalInsurancesFields2 &&
      !this.state.cardHolderId3
    ) {
      alert("Please enter the member id");
      formIsValid = false;
    } else if (
      this.state.showAdditionalInsurancesFields2 &&
      !this.state.binNumber3
    ) {
      alert("Please enter the rxbin");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ resultSuccessful: false });

      const apiName = "ApaqPortalAPI";
      const path = "/pharmacy-customer/update/insurance-plan";
      const config = {
        body: {
          binNumber: this.state.binNumber,
          binNumber2: this.state.binNumber2,
          binNumber3: this.state.binNumber3,
          cardHolderId: this.state.cardHolderId,
          cardHolderId2: this.state.cardHolderId2,
          cardHolderId3: this.state.cardHolderId3,
          groupNumber: this.state.groupNumber,
          groupNumber2: this.state.groupNumber2,
          groupNumber3: this.state.groupNumber3,
          pcn: this.state.pcn,
          pcn2: this.state.pcn2,
          pcn3: this.state.pcn3,
          personId: this.state.personId,
          setInsuranceAsPrimary: this.state.setInsuranceAsPrimary,
          setInsuranceAsPrimary2: this.state.setInsuranceAsPrimary2,
          setInsuranceAsPrimary3: this.state.setInsuranceAsPrimary3,
          spi: this.state.spi,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ resultSuccessful: true });
          this.setState({ formSubmitted: false });
          this.setState({ personId: "" });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(InsurancePlanSection);
